<style scoped>
  .about-holder{
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
</style>

<style>
  .about-mynd > .ivu-modal > .ivu-modal-content > .ivu-modal-header{
    border-bottom: 0;
  }
</style>


<template>
  <ModalHolder title="" m-top="30" m-height="70vh" :class-name="'about-mynd'" :is-show="showMyndModal">
    <template slot="mcontent">
      <span style="position:absolute;right:15px;top:15px" @click="dismissModal()">
        <img :src="closeIcon" style="height: 25px;"/>
      </span>
      <div class="about-holder" style="height: 100%; justify-content: center">
        <!-- <img :src="myndLogo"/>
        <p style="margin-top: 10px;font-size: 2.7vh;">Mynd develops world-class, socially-enabled mobile apps and Mobile Engagement Ecosystems.</p>
        <img :src="emmyLogo"  style="margin-top: 10px;width:100%"/>
        <p style="margin-top: 10px;font-size: 1.9vh;">An app built using our technology was nominated for a 2017 Emmy Award.</p>
        <p style="margin-top: 10px;font-size: 2.7vh;line-height:15px">
          <a style="font-weight:bolder;font-style:underline" @click="toStory" target="_blank">Myrna's Story</a><br/>
          <small><a href="mailto:myrna@myndconsulting.com" target="_top" style="margin-top: 10px;font-size: 1.9vh;">myrna@myndconsulting.com</a></small>
        </p> -->
        <h2>
          Coming soon...
        </h2>
      </div>
    </template>
  </ModalHolder>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";

export default {
  name: 'ShareModalComponent',
  components: {
    ModalHolder
  },
  computed: {
    myndLogo: {
      get() {
        return require('@/assets/mynd.png')
      }
    },
    emmyLogo: {
      get() {
        return require('@/assets/emmy.png')
      }
    },
    showMyndModal: {
      get() {
        return this.$store.state.publicModule.showAboutMynd
      }
    },
    closeIcon: {
      get() {
        return require('@/assets/close.png')
      }
    }
  },
  methods: {
    toStory() {
      this.dismissModal()
      this.$router.push({ path: '/feed/' + Cons[0].GROUP_ID.myrnaStoryActivityId[process.env.VUE_APP_DEV_STATUS] })
    },
    dismissModal() {
      this.$store.commit('publicModule/setShowAboutMynd', false);
    }
  }
}

</script>
